import styles from './service-unavailable.module.less';

export type ServiceUnavailableVariant = 'editorial' | 'split' | 'compact';

interface ServiceUnavailableProps {
    siteName: string;
    variant?: ServiceUnavailableVariant;
}

export function ServiceUnavailable({
    siteName,
    variant = 'editorial',
}: ServiceUnavailableProps) {
    const variantClassName = {
        editorial: styles.variant_editorial,
        split: styles.variant_split,
        compact: styles.variant_compact,
    }[variant];

    const eyebrow = {
        editorial: 'Regional Notice',
        split: 'Access Restricted',
        compact: 'Service Unavailable',
    }[variant];


    const message = {
        editorial: `Unfortunately, ${siteName} services are not accessible in your region at this time.`,
        split: `We regret to inform you that ${siteName} isn’t available for your current location.`,
        compact: `Sorry, access to ${siteName} is restricted in the area you’re browsing from.`,
    }[variant];

    return (
        <section className={[styles.unavailablePage, variantClassName].join(' ')}>
            <div className={styles.backdrop} aria-hidden="true" />
            <div className={styles.inner}>
                <div className={styles.copyBlock}>
                    <h1 className={styles.eyebrow}>{eyebrow}</h1>
                    {/* <h1 className={styles.title}>Service unavailable in this region</h1> */}
                    <p className={styles.description}>
                        {message}
                    </p>
                </div>
            </div>
        </section>
    );
}
